
var constants = require('./lib/constants');
exports.amf0Types = constants.amf0Types;
exports.amf3Types = constants.amf3Types;

exports.read = require('./lib/read');
exports.write = require('./lib/write');



//////////////////
// WEBPACK FOOTER
// ./~/amf/index.js
// module id = 242
// module chunks = 0